module.exports = __webpack_public_path__ + "static/img/title_bg.5f3a1cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_image/title_bg.png
// module id = nWkj
// module chunks = 20